/**
 * Load More Posts Functionality
 *
 * Handles AJAX loading of additional posts on category and taxonomy archive pages.
 *
 * @package Karuna_Hospice
 */

/**
 * Initialize load more functionality
 */
export function initLoadMore() {
	const loadMoreButtons = document.querySelectorAll( '[data-load-more]' );
	
	if ( ! loadMoreButtons.length ) {
		return;
	}
	
	// Check if karunaLoadMore is available (localized from PHP)
	if ( typeof karunaLoadMore === 'undefined' ) {
		console.warn( 'karunaLoadMore is not defined. Make sure the script is properly localized.' );
		return;
	}
	
	loadMoreButtons.forEach( ( button ) => {
		button.addEventListener( 'click', handleLoadMoreClick );
	} );
}

/**
 * Handle load more button click
 */
function handleLoadMoreClick( event ) {
	const button = event.currentTarget;
	const container = document.querySelector( '[data-posts-container]' );
	
	if ( ! container ) {
		console.error( 'Posts container not found' );
		return;
	}
	
	// Disable button and show loading state
	button.disabled = true;
	const originalText = button.textContent;
	button.textContent = 'LOADING...';
	
	// Get data attributes
	const postType = button.getAttribute( 'data-post-type' ) || 'post';
	const taxonomy = button.getAttribute( 'data-taxonomy' ) || 'category';
	const termId = button.getAttribute( 'data-term-id' ) || '0';
	const currentPage = parseInt( button.getAttribute( 'data-current-page' ) || '1', 10 );
	const maxPages = parseInt( button.getAttribute( 'data-max-pages' ) || '1', 10 );
	const postsPerPage = parseInt( button.getAttribute( 'data-posts-per-page' ) || '6', 10 );
	const excludePosts = button.getAttribute( 'data-exclude-posts' ) || '[]';
	
	// Calculate next page
	const nextPage = currentPage + 1;
	
	// Prepare AJAX request
	const formData = new FormData();
	formData.append( 'action', 'karuna_load_more_posts' );
	formData.append( 'nonce', karunaLoadMore.nonce );
	formData.append( 'post_type', postType );
	formData.append( 'taxonomy', taxonomy );
	formData.append( 'term_id', termId );
	formData.append( 'page', nextPage );
	formData.append( 'posts_per_page', postsPerPage );
	formData.append( 'exclude_posts', excludePosts );
	
	// Make AJAX request
	fetch( karunaLoadMore.ajaxUrl, {
		method: 'POST',
		body: formData,
	} )
		.then( ( response ) => response.json() )
		.then( ( data ) => {
			if ( data.success && data.data ) {
				// Append new posts to container
				const tempDiv = document.createElement( 'div' );
				tempDiv.innerHTML = data.data.html;
				
				// Append each post to container
				while ( tempDiv.firstChild ) {
					container.appendChild( tempDiv.firstChild );
				}
				
				// Update button attributes
				button.setAttribute( 'data-current-page', nextPage );
				
				// Check if there are more pages
				if ( ! data.data.has_more ) {
					// Hide button if no more posts
					const loadMoreContainer = button.closest( '[data-load-more-container]' );
					if ( loadMoreContainer ) {
						loadMoreContainer.style.display = 'none';
					}
				} else {
					// Re-enable button
					button.disabled = false;
					button.textContent = originalText;
				}
			} else {
				// Handle error
				console.error( 'Error loading more posts:', data.data?.message || 'Unknown error' );
				button.disabled = false;
				button.textContent = originalText;
			}
		} )
		.catch( ( error ) => {
			// Handle network error
			console.error( 'Network error loading more posts:', error );
			button.disabled = false;
			button.textContent = originalText;
		} );
}


